// extracted by mini-css-extract-plugin
export default {"work-rules":"AutorunTable_work-rules__zfHzw","table":"AutorunTable_table__OlUCl","workRules_violet":"AutorunTable_workRules_violet__At3Z5"};